import React from 'react';
import { Dialog, DialogTitle, IconButton, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@/public/icons/close_black.svg';
import AttachmentFile from '@/components/AttachmentFile';
import { RemoteFile } from '@/components/file-thumbnail/utils';

type AttachmentDialogProps = {
  open: boolean;
  onClose: () => void;
  files: RemoteFile[];
  disabled?: boolean;
};

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    width: '560px',
    maxWidth: 'calc(100vw - 48px)',
    borderRadius: '8px',
    boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.08)',
  },
});

const StyledDialogTitle = styled(DialogTitle)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '48px',
  padding: '12px 16px 12px 20px',
  boxSizing: 'border-box',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  borderBottom: '1px solid var(--dk-line, #E7E9EC)',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
});

// Use plain Box instead of DialogContent to avoid MUI's padding-top override
// when DialogContent follows DialogTitle
const DialogBody = styled(Box)({
  padding: '24px 24px 32px 24px',
});

const FileGrid = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 8,
});

const AttachmentDialog: React.FC<AttachmentDialogProps> = ({
  open,
  onClose,
  files,
  disabled,
}) => {
  return (
    <StyledDialog open={open} onClose={onClose}>
      <StyledDialogTitle>
        첨부 파일
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ padding: 0, margin: 0, width: 24, height: 24 }}
          aria-label="닫기"
        >
          <CloseIcon width={24} height={24} />
        </IconButton>
      </StyledDialogTitle>
      <DialogBody>
        <FileGrid>
          {files.map((file, index) => (
            <AttachmentFile
              key={index}
              file={file}
              disabled={disabled}
              isDeletable={false}
              isPreviewable={true}
            />
          ))}
        </FileGrid>
      </DialogBody>
    </StyledDialog>
  );
};

export default AttachmentDialog;
